<template>
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none">
        <path
            d="M0.878418 10.9375V13.75H3.69092L11.9859 5.45504L9.17342 2.64254L0.878418 10.9375ZM14.1609 3.28004C14.4534 2.98754 14.4534 2.51504 14.1609 2.22254L12.4059 0.467544C12.1134 0.175044 11.6409 0.175044 11.3484 0.467544L9.97592 1.84004L12.7884 4.65254L14.1609 3.28004Z"
            :fill="color"
        />
    </svg>
</template>

<script>
export default {
    name: 'Pencil',
    props: {
        color: {
            type: String,
            default: '#A1A8AF',
        },
    },
}
</script>

<style></style>
